import { Injectable } from "@angular/core";
import { createSelector } from "@ngrx/store";
import { castArray } from "lodash-es";

import { ContentGroupType, ImageContent } from "../content/content.model";
import { CoreContentState } from "../state";

import { ImageContentDictionary, Images } from "./image.model";
/**
 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class ImageSelector {
	private getImages() {
		return (state: CoreContentState): Images => state.image.images;
	}

	isBusy() {
		return (state: CoreContentState): boolean => state.image.isBusy;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	getAll = (group: ContentGroupType) =>
		createSelector(this.getImages(), (images): ImageContentDictionary | undefined => images[group]);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	getByKey = (group: ContentGroupType, key: string, defaultKey?: string | string[]) =>
		createSelector(this.getAll(group), (imageGroup): ImageContent | undefined => {
			const images = imageGroup?.images;

			if (!images) {
				return undefined;
			}

			const finalKey = [key, ...castArray(defaultKey)].find((k) => !!images[k]);
			return (finalKey && images[finalKey]) || undefined;
		});

	getIconByKey = (group: ContentGroupType, key: string, defaultKey?: string | string[]) =>
		createSelector(this.getAll(group), (imageGroup): ImageContent | undefined => {
			const icons = imageGroup?.icons;

			if (!icons) {
				return undefined;
			}

			const finalKey = [key, ...castArray(defaultKey)].find((k) => !!icons[k]);
			return (finalKey && icons[finalKey]) || undefined;
		});

	getFlagByKey = (group: ContentGroupType, key: string, defaultKey?: string | string[]) =>
		createSelector(this.getAll(group), (imageGroup): ImageContent | undefined => {
			const flags = imageGroup?.flags;

			if (!flags) {
				return undefined;
			}

			const finalKey = [key, ...castArray(defaultKey)].find((k) => !!flags[k]);
			return (finalKey && flags[finalKey]) || undefined;
		});
}
